import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Crown } from 'lucide-react';
import { TermlyScriptWrapper } from './TermlyScriptWrapper';

export function TermsOfService() {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <Helmet>
        <title>Terms of Service - RoyaltySuite</title>
        <meta name="description" content="Read our Terms of Service to understand your rights and responsibilities when using RoyaltySuite." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="flex items-center gap-3 mb-8">
        <div className="relative">
          <div className="absolute inset-0 bg-royal-purple/20 rounded-full blur-lg" />
          <Crown className="w-8 h-8 text-royal-purple relative" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">Terms of Service</h1>
      </div>

      <div className="bg-white dark:bg-dark-paper rounded-xl shadow-sm">
        <div className="p-8">
          <TermlyScriptWrapper 
            policyId="460aef9b-1e2f-4ab5-874a-c38ecb5019db"
            className="min-h-[800px]"
          />
        </div>
      </div>
    </div>
  );
}